'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _BillingNameKeys = require('self-service-api/constants/BillingNameKeys');

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _PurchaseTypes = require('self-service-api/constants/PurchaseTypes');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _ActiveHubSelectors = require('pricing-pages-unified-ui/selectors/ActiveHubSelectors');

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerAdditionalUnitSubtext = function PerAdditionalUnitSubtext(_ref) {
  var merchId = _ref.merchId,
      currencyCode = _ref.currencyCode,
      costPerUnit = _ref.costPerUnit;

  var billingNameKey = _ImmutableMerchandiseIdMap2.default[merchId].billingNameKey;
  if (!(0, _merchUtils.isAdditionalUnitsMerchIdSameAsBaseMerchId)(merchId) && !_MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.includes(merchId)) {
    return null;
  }
  var langPath = billingNameKey === _BillingNameKeys.ADDITIONAL_CONTACTS ? 'additionalContacts_jsx' : 'additionalUsers_jsx';
  return _react2.default.createElement(_FormattedJSXMessage2.default, {
    message: 'pricingPage.calculator.priceBreakdown.perAdditionalUnitSubtext.' + langPath,
    options: {
      price: costPerUnit,
      currencyCode: currencyCode
    },
    elements: { PriceDisplay: _PriceDisplay2.default, FormattedNumber: _FormattedNumber2.default }
  });
};

PerAdditionalUnitSubtext.propTypes = {
  merchId: _react.PropTypes.number.isRequired,
  costPerUnit: _react.PropTypes.number,
  currencyCode: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchId = _ref2.merchId,
      termId = _ref2.termId;

  var activeHub = (0, _ActiveHubSelectors.activeHubSelector)(state);
  var merchPurchaseType = _HubMap2.default[activeHub].merchPurchaseType;


  var costPerUnit = null;

  if (merchPurchaseType === _PurchaseTypes.CONTACT_BASED) {
    costPerUnit = (0, _PricingSelectors.additionalContactsMonthlyCostSelector)(state, merchId, termId);
  } else if (merchPurchaseType === _PurchaseTypes.SEAT_BASED) {
    costPerUnit = (0, _PricingSelectors.additionalSeatMonthlyCostSelector)(state, merchId, termId);
  }

  return { costPerUnit: costPerUnit };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PerAdditionalUnitSubtext);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PerAdditionalUnitSubtext.js
// module id = 745
// module chunks = 3 4